import { MediaContent } from '@/components/inbox/messages/MediaContent';
import type { Message } from '@/hooks/useConversationMessages';
import { teamChatAttachmentKind } from '@/lib/chat/teamChatAttachments';

interface TeamChatAttachmentProps {
  messageType: string | null | undefined;
  metadata: { url?: string; originalName?: string; mimeType?: string; size?: number } | null | undefined;
}

/**
 * A team chat attachment, shown with the inbox's own media components:
 * image preview, video and audio players, and the document card with
 * preview and download. Returns null when the message is not an attachment.
 */
export function TeamChatAttachment({ messageType, metadata }: TeamChatAttachmentProps) {
  const kind = teamChatAttachmentKind(messageType, metadata?.mimeType);
  if (!kind || !metadata?.url) return null;

  // The inbox components read the inbox message shape.
  const asInboxMessage = {
    message_type: kind,
    media_type: kind,
    media_url: metadata.url,
    mediaFilename: metadata.originalName,
    mediaSize: metadata.size,
    content_text: '',
  } as unknown as Message;

  return <MediaContent message={asInboxMessage} />;
}
